import React, { createContext, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import styles from '../styles/AdminLayout.module.css';
import Account from '../pages/Account';

export const AdminContext = createContext({ admin: { email: 'admin@klcreation.com' } });

const AdminRoutes = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const handleSidebarToggle = () => setSidebarOpen((open) => !open);

  return (
    <AdminContext.Provider value={{ admin: { email: 'admin@klcreation.com' } }}>
      <div className={
        styles.adminLayout + ' ' + (sidebarOpen ? styles.sidebarOpen : styles.sidebarClosed)
      }>
        {sidebarOpen && <Sidebar />}
        <div className={styles.mainArea}>
          <Navbar onSidebarToggle={handleSidebarToggle} />
          <main className={styles.contentArea}>
            <Outlet />
          </main>
        </div>
      </div>
    </AdminContext.Provider>
  );
};

export default AdminRoutes;